import { FC, useContext, useRef, useState} from "react"
import { AgGridColumn, AgGridReact } from "ag-grid-react"
import '../../../../../ag-grid.css'
import '../../../../../ag-theme-alpine.css'
import { warning } from "../../../../../utils/notifications"
import { EditEnergiaModalDialog } from "./EditEnergiaModalDialog/EditEnergiaModalDialog"
import { diferencialDefaultRenderer } from "../../../../../utils/helperFunctions"
import { UserContext } from "../../../../../Redux/UserContext"

export const EnergiaTable:FC<any> = (props) => {

    const gridRef :any= useRef();

    const { data, setData, dataMASTER, simulated,original, saveLoading , same, scenarioBase} = props

    const [state] = useContext(UserContext)

    const [ visible, setVisible ] = useState<boolean>(false)

    const [ selectedCell, setSelectedCell ] = useState<any>()

    const [ selectedRow, setSelectedRow ] = useState<any>()

    const [ mode, setMode] = useState<string>("")

    const [ type, setType ] = useState<string>("PKM")

    const handleClose = () => {
        setSelectedCell(undefined)
        setSelectedRow(undefined)
        setVisible(false)
        setMode("")
    }

    

    const handleEditCellContentP = (params:any) => {
        let { colId } = params.column
        if(colId !== 'name_plant') {
            setType("P")
            let modo = colId.split("_")
            modo.slice(-1)[0] === 'a'? setMode("base") : setMode("comparision")
            if(modo.slice(-1)[0] === 'a') {
                if(simulated.scenario_base && !original.scenario_base) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_base && colId !== 'stock_minimo_a' && colId !== 'stock_maximo_a') {
                    warning("No se puede en editar el escenario original.")
                } else if(original.scenario_base) {
                    warning("No se puede editar el escenario original.")
                } else if(same) {
                    warning('Estás tratando de editar los parámetros del mismo escenario. Sal del modo "comparación" para poder editarlo.')
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            } else {
                if(simulated.scenario_comparision && !original.scenario_comparision) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_comparision && colId !== 'stock_minimo_b' && colId !== 'stock_maximo_b') {
                    warning("No se puede editar en el escenario original.")
                } else if(original.scenario_comparision) {
                    warning("No se puede editar el escenario original.")
                } else if(same) {
                    warning('Estás tratando de editar los parámetros del mismo escenario. Sal del modo "comparación" para poder editarlo.')
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            }
        }
        
        
    }

    const handleEditCellContentM = (params:any) => {
        let { colId } = params.column
        if(colId !== 'mes' && colId !== 'energia_a' && colId !== 'energia_b' && colId !== 'anio') {
            setType("M")
            let modo = colId.split("_")
            modo.slice(-1)[0] === 'a'? setMode("base") : setMode("comparision")
            if(modo.slice(-1)[0] === 'a') {
                if(simulated.scenario_base && !original.scenario_base) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_base && colId !== 'stock_minimo_a' && colId !== 'stock_maximo_a') {
                    warning("No se puede editar en el escenario original.")
                } else if(original.scenario_base) {
                    warning("No se puede editar el escenario original.")
                } else if(same) {
                    warning('Estás tratando de editar los parámetros del mismo escenario. Sal del modo "comparación" para poder editarlo.')
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            } else {
                if(simulated.scenario_comparision && !original.scenario_comparision) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_comparision && colId !== 'stock_minimo_b' && colId !== 'stock_maximo_b') {
                    warning("No se puede editar en el escenario original.")
                } else if(original.scenario_comparision) {
                    warning("No se puede editar el escenario original.")
                } else if(same) {
                    warning('Estás tratando de editar los parámetros del mismo escenario. Sal del modo "comparación" para poder editarlo.')
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            }
        }
        
        
    }

    const handleCellStylePEditable = (params:any) => {
        let original = dataMASTER.energy_plant_table.find((ori:any) => ori.id_plant === params.data.id_plant)?.[params.column.colId]
        if(original != params.value) {
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',height:'100%',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',height:'100%',borderRight:'1px solid #dee2e6'}
        }   
    }

    const handleCellStyleMEditable = (params:any) => {
        let original = dataMASTER.energy_month_table.find((ori:any) => ori.mes === params.data.mes)?.[params.column.colId]
        if(original != params.value) {
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',height:'100%',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',height:'100%',borderRight:'1px solid #dee2e6'}
        }   
    }

    const handleCellStyleP = (params:any) => {
        let original = dataMASTER.energy_plant_table.find((ori:any) => ori.id_plant === params.data.id_plant)?.[params.column.colId]
       
        if(original != params.value) {
            
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'rgb(236, 236, 236)',color: 'black',fontWeight:'normal',borderRight:'1px solid #dee2e6'}
        } 
    }

    const handleCellStyleM = (params:any) => {
        let original = dataMASTER.energy_month_table.find((ori:any) => ori.mes === params.data.mes)?.[params.column.colId]
       
        if(original != params.value) {
            
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'rgb(236, 236, 236)',color: 'black',fontWeight:'normal',borderRight:'1px solid #dee2e6'}
        } 
    }
    

    return (
        <div className="energiatable__wrapper">
            <EditEnergiaModalDialog
                    visible={visible}
                    setVisible={setVisible}
                    handleClose={handleClose}
                    selectedCell={selectedCell}
                    setSelectedCell={setSelectedCell}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    mode={mode}
                    setMode={setMode}
                    data={data}
                    dataMASTER={dataMASTER}
                    setData={setData}
                    type={type}   
                />
            <div className="ag-theme-alpine" style={saveLoading? {display:'flex',flexDirection:'column', height:'100%', width: '44%',opacity:0.6 } : {display:'flex',flexDirection:'column', height:'100%', width: '44%' }}>
            {
                    saveLoading?
                        <div className="scenario__overlay-table"></div>
                        :
                        false
                }
                <AgGridReact
                    ref={gridRef}
                    headerHeight={30}
                    getRowHeight={() => 30}
                    onCellDoubleClicked={state?.rol_id !== undefined? [3,4].includes(state.rol_id) && !state.id_plants.includes(scenarioBase.id_plant) ? () => warning("No tienes permisos para realizar esta acción") : handleEditCellContentP : () => warning("No tienes permisos para realizar esta acción")}
                    rowData={data?.energy_plant_table}
                    enableCellTextSelection
                    >
                    <AgGridColumn sortable   suppressNavigable={true} cellStyle={handleCellStyleP} flex={1} hide   headerName={"ID Planta"} field={"id_plant"}></AgGridColumn>
                    <AgGridColumn sortable   suppressNavigable={true} flex={1} cellStyle={handleCellStyleP} headerClass={"header-resize"}  headerName={"Planta"} field={"name_plant"}></AgGridColumn>

                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Stock inicial" flex={1} >
                        <AgGridColumn cellStyle={handleCellStylePEditable} sortable headerClass={"var(--lis-dark)-column header-resize"} cellRenderer={diferencialDefaultRenderer}  flex={1} suppressNavigable  headerName="Esc A" field="stock_inicial_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStylePEditable}  sortable headerClass={"var(--lis-alternative)-column header-resize"} cellRenderer={diferencialDefaultRenderer}  flex={1} suppressNavigable  headerName="Esc B" field="stock_inicial_b"></AgGridColumn>
                    </AgGridColumn>
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Stock mínimo" flex={1} >
                        <AgGridColumn cellStyle={handleCellStylePEditable} sortable headerClass={"var(--lis-dark)-column header-resize"} cellRenderer={diferencialDefaultRenderer} flex={1} suppressNavigable  headerName="Esc A" field="stock_minimo_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStylePEditable}  sortable headerClass={"var(--lis-alternative)-column header-resize"} cellRenderer={diferencialDefaultRenderer} flex={1} suppressNavigable  headerName="Esc B" field="stock_minimo_b"></AgGridColumn>
                    </AgGridColumn>
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Stock máximo" flex={1} >
                        <AgGridColumn cellStyle={handleCellStylePEditable} sortable headerClass={"var(--lis-dark)-column header-resize"} cellRenderer={diferencialDefaultRenderer} flex={1} suppressNavigable  headerName="Esc A" field="stock_maximo_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStylePEditable}  sortable headerClass={"var(--lis-alternative)-column header-resize"} cellRenderer={diferencialDefaultRenderer} flex={1} suppressNavigable  headerName="Esc B" field="stock_maximo_b"></AgGridColumn>
                    </AgGridColumn>
    
                </AgGridReact>
            </div>
            <div className="ag-theme-alpine" style={saveLoading? {display:'flex',flexDirection:'column', height:'100%', width: '55%',opacity:0.6 } : {display:'flex',flexDirection:'column', height:'100%', width: '55%' }}>
            {
                    saveLoading?
                        <div className="scenario__overlay-table"></div>
                        :
                        false
                }
                <AgGridReact
                    ref={gridRef}
                    headerHeight={30}
                    getRowHeight={() => 30}
                    onCellDoubleClicked={state?.rol_id !== undefined? [3,4].includes(state.rol_id) && !state.id_plants.includes(scenarioBase.id_plant) ? () => warning("No tienes permisos para realizar esta acción") : handleEditCellContentM : () => warning("No tienes permisos para realizar esta acción")}
                    rowData={data?.energy_month_table.sort((a:any,b:any) => {
                        if (a.anio !== b.anio) {
                            return a.anio - b.anio;
                          }
                          // Si los años son iguales, ordena por mes
                          return a.id_mes - b.id_mes;
                    })}
                    enableCellTextSelection
                    >
                    <AgGridColumn sortable headerClass={"header-resize"} cellStyle={handleCellStyleM}  suppressNavigable={true} flex={1}  headerName={"Mes"} field={"mes"}></AgGridColumn>
                    <AgGridColumn sortable headerClass={"header-resize"} cellStyle={handleCellStyleM}  suppressNavigable={true} flex={1}  headerName={"Año"} field={"anio"}></AgGridColumn>
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Toneladas de herbáceo" flex={1} >
                        <AgGridColumn cellStyle={handleCellStyleMEditable} sortable headerClass={"var(--lis-dark)-column header-resize"} cellRenderer={diferencialDefaultRenderer}  flex={1} suppressNavigable  headerName="Esc A" field="toneladas_herbaceo_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStyleMEditable}  sortable headerClass={"var(--lis-alternative)-column header-resize"} cellRenderer={diferencialDefaultRenderer}   flex={1} suppressNavigable  headerName="Esc B" field="toneladas_herbaceo_b"></AgGridColumn>
                    </AgGridColumn>
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Toneladas de leñoso" flex={1} >
                        <AgGridColumn cellStyle={handleCellStyleMEditable} sortable headerClass={"var(--lis-dark)-column header-resize"} cellRenderer={diferencialDefaultRenderer}  flex={1} suppressNavigable  headerName="Esc A" field="toneladas_lenoso_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStyleMEditable}  sortable headerClass={"var(--lis-alternative)-column header-resize"}  cellRenderer={diferencialDefaultRenderer}  flex={1} suppressNavigable  headerName="Esc B" field="toneladas_lenoso_b"></AgGridColumn>
                    </AgGridColumn>
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Energía (MWh)" flex={1} >
                        <AgGridColumn cellStyle={handleCellStyleM} sortable headerClass={"var(--lis-dark)-column header-resize"} cellRenderer={diferencialDefaultRenderer} flex={1} suppressNavigable  headerName="Esc A" field="energia_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStyleM}  sortable headerClass={"var(--lis-alternative)-column header-resize"}  cellRenderer={diferencialDefaultRenderer}  flex={1} suppressNavigable  headerName="Esc B" field="energia_b"></AgGridColumn>
                    </AgGridColumn>
    
                </AgGridReact>
                
            </div>
        </div>
    )
}